export default "__VITE_ASSET__DEYm6nH4__"